// ═══════════════════════════════════════════════════════════════════
//  CourrielListe.js
//  Colonne de gauche : la liste des messages — extrait de Courriel
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { URGENCE_COLOR } from "./constantes";
import { btnStyle, mailDate } from "./utils";
import { TagPill } from "./TagPill";

export function CourrielListe({ dossier, estBoiteRecue, filtre, isMobile, liste, messages, ouvrir, recherche, reindexation, reindexer, selection }) {
  return (
    (!isMobile || !selection) && (
      <div style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 12, overflow: "hidden" }}>
        {!liste && <div style={{ padding: 18, color: THEME.textDim, fontSize: 13 }}>Chargement…</div>}
        {liste && messages.length === 0 && (
          <div style={{ padding: 18, color: THEME.textDim, fontSize: 13 }}>
            Aucun message pour ce filtre.
            {estBoiteRecue && !filtre && !recherche && (
              <div style={{ marginTop: 12 }}>
                <div style={{ marginBottom: 8, lineHeight: 1.5 }}>
                  Si la boîte contient pourtant des messages, ils ne sont pas encore indexés.
                </div>
                <button onClick={reindexer} disabled={reindexation} style={{ ...btnStyle(true), opacity: reindexation ? .6 : 1 }}>
                  {reindexation ? "Réindexation…" : "⟳ Réindexer la boîte"}
                </button>
              </div>
            )}
          </div>
        )}
        {messages.map((m, i) => (
          <div key={m.uid} onClick={() => ouvrir(m.uid)} style={{
            display: "flex", gap: 11, padding: "11px 14px", cursor: "pointer",
            borderBottom: i < messages.length - 1 ? `1px solid ${THEME.border}` : "none",
            background: selection?.uid === m.uid ? THEME.panel : (m.seen ? "transparent" : "rgba(79,142,247,0.06)"),
          }}>
            <div style={{
              width: 30, height: 30, borderRadius: 9, flexShrink: 0, display: "grid", placeItems: "center",
              background: m.seen ? THEME.panel : THEME.accentDim,
              color: m.seen ? THEME.textMuted : "#9CC2FF", fontSize: 12, fontWeight: 800,
            }}>{(m.from || "?").trim().charAt(0).toUpperCase()}</div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 1 }}>
                <span style={{ color: THEME.text, fontSize: 13, fontWeight: m.seen ? 600 : 800,
                               overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {dossier === "sent" && <span style={{ color: THEME.textDim, fontWeight: 600 }}>À </span>}
                  {m.from}
                </span>
                {m.tag && <TagPill tag={m.tag} />}
                {m.ticketId && <span style={{ fontSize: 10, color: THEME.emerald, fontWeight: 700 }}>#{m.ticketId}</span>}
              </div>
              <div style={{ color: THEME.textMuted, fontSize: 12.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {m.hasAttachments && "📎 "}{m.subject}
              </div>
              {m.ia?.intention && (
                <div style={{ color: THEME.purple, fontSize: 11, marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  ✦ {m.ia.intention}
                  {m.ia.urgence && <span style={{ color: URGENCE_COLOR[m.ia.urgence] || THEME.textDim }}> · {m.ia.urgence}</span>}
                </div>
              )}
            </div>
            <div style={{ color: THEME.textDim, fontSize: 11, flexShrink: 0 }}>{mailDate(m.date, true)}</div>
          </div>
        ))}
      </div>
    )
  );
}
